import { Button } from '@nextui-org/react';
import { Icon } from '@iconify/react';

// Botón que abre y cierra el panel de filtros lateral (ModalSlideFilter).
// Va debajo del Header, a la izquierda. El texto lo pasa la página ya
// traducido ("Mostrar filtros" / "Ocultar filtros"). Ver design.md › Patrones.
const FiltersToggle = ({
  isOpen,
  onToggle,
  label,
}: {
  isOpen: boolean;
  onToggle: () => void;
  label: string;
}) => (
  <Button
    size='sm'
    variant='flat'
    className='w-fit'
    aria-expanded={isOpen}
    startContent={<Icon icon='tabler:filter-2' />}
    onPress={onToggle}
  >
    {label}
  </Button>
);

export default FiltersToggle;
